export default "__VITE_ASSET__df25dfe9__"